export { SecurityModule } from './security.module';



// WEBPACK FOOTER //
// /dist/src/app/security/index.ts